import { ChangeDetectorRef, Component, ElementRef, EventEmitter,
  Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { Router } from '@angular/router';
import { ApiService } from '../../../../../@core/service/api.service';
import { AuthGuardService } from '../../../../../@core/service/auth-guard.service';
import { SharedDataService } from '../../../../../@core/service/shared-data.service';
import { UserModel, BusinessModel, BusinessUnitModel } from '../../../../../@models';
import { FinishedProductModel } from '../../../../../@models/erp/finishedProduct';
import { ReportsComponent } from '../../reports.component';
import { CommonPrinter } from '../commonPrinter';
import { mongoId } from '../../../../../@core/common/global';

export enum ChartType {
  turnover = 1,
  customer = 2,
}

@Component({
  selector: 'ngx-customer-printer',
  templateUrl: './customer.component.html',
  styleUrls: ['../reports-printer.component.css'],
})
export class CustomerComponent extends CommonPrinter implements OnInit, OnChanges {

  @Input() search: any;
  @Input() pdfSidebar: boolean;
  // @Input() users: UserModel[];
  // @Input() businesses: BusinessModel[];
  // @Input() businessUnits: BusinessUnitModel[];
  @Output() done = new EventEmitter<string>();
  @Output() back = new EventEmitter<void>();

  // series = {
  //   intervals: {
  //     bars: [],
  //     lines : [],
  //   },
  //   years: {
  //     bars: [],
  //     lines: [],
  //   },
  // };

  chartType: ChartType;
  attachedReports: any = [];
  showCharts = true;

  reportsLoaded = 0;

  finishedProductNames = 'All';

  secondRun = false;

  constructor(private elRef: ElementRef, private auth: AuthGuardService,
    private api: ApiService, private cdRef: ChangeDetectorRef, private router: Router, public data: SharedDataService) {

    super(elRef, api, auth, data);
  }

  ngOnInit() {
    if (!this.auth.user.erpRoles.admin && !this.auth.user.erpRoles.customerReport) {
      this.router.navigateByUrl('/pages/403');
    }
    super.init();
    this.showCharts = this.search.customeroverview && this.search.customeroverview.showCharts;
    this.reloadData();
    // console.log('init customer report')
  }

  async ngOnChanges(changes: SimpleChanges) {
    if (changes.search && changes.search.currentValue) {
      this.reloadData();
    }
  }

  async reloadData() {
    // TODO: improve performance, use only one api call
    this.reportsLoaded = 0;
    const type = this.getType();
    this.query = this.search[type];
    if (this.search[type] && this.search[type].dateFrom) {
      this.search[type].dateFrom.setHours(2);
      this.search[type].dateFrom.setMinutes(0);
      this.search[type].dateFrom.setSeconds(0);
    }
    if (this.search[type] && this.search[type].dateTo) {
      this.search[type].dateTo.setHours(23);
      this.search[type].dateTo.setMinutes(59);
      this.search[type].dateTo.setSeconds(59);
    }

    const fpids = this.query.finishedProducts;
    if (fpids && fpids.length) {
      const fps = await Promise.all(fpids.map(async id => await this.api.loadFinishedProductById(id))) as FinishedProductModel[];
      this.finishedProductNames = fps && fps.length ? fps.map(fp => fp.calcName).join('\n') : 'All';
    }

    this.pdfData = await this.api.getDocumentReportAsync2(type, this.search, true);

    console.log('customer component pdf data', this.pdfData);

    // console.log('===> pdf data', type, this.search, this.pdfData?.tables, this.pdfData?.charts, this.pdfData)

    this.attachedReports = this.getAttachedReports();

    this.cdRef.detectChanges();



    // this.series = {
    //   intervals: {
    //     bars: this.getYearSeries(this.pdfData.intervals),
    //     lines:  this.getYearSeries(this.pdfData.intervals, false),
    //   },
    //   years: {
    //     bars: this.getYearSeries(this.pdfData.years),
    //     lines:  this.getYearSeries(this.pdfData.years, false),
    //   },
    // }
  }

  // getYearSeries(data: any, bars = true) {
  //   let ret;
  //   if (bars) {
  //     ret = data.map(m => ({ name: ''+m.data[0].year, value: (m.data[0] && m.data[0].price) || 0 })).reverse();
  //   } else {
  //     ret = [{
  //       name: 'Year',
  //       series :data.map(m => ({ name: ''+m.data[0].year, value: (m.data[0] && m.data[0].price) || 0 })).reverse(),
  //     }]
  //   }
  //   return ret;
  // }

  showChart(chart: string) {
    const type = this.getType();
    switch (chart) {
      case 'yearChart':
        if (!this.search[type] || !this.search[type].dateFrom || !this.search[type].dateFrom.toISOString()) return true;
        return !(this.search[type].dateFrom.toISOString().match(/\d\d\d\d-01-01/)
          && this.search[type].dateTo.toISOString().match(/\d\d\d\d-12-31/))
      default:
        return this.pdfData.charts?.[chart] != null;
    }
  }

  getAttachedReports() {
    const search = this.search.customeroverview;
    let reports = [];
    const tmp = [];

    // console.log('gat attached pre', search, search.attachedReports);

    for (const r in search.attachedReports) {
      if (search.attachedReports[r].show === true) {
        const params: any = {};

        // let sr = false;
        // if (r === 'srpfin') {
        //   sr = true;
        //   r = 'lastinvoices';
        // } else if ( r === 'srnoninvoiced') {
        //   sr = true;
        //   r = 'noninvoiced';
        // }
        const sr = (/^sr.*/).test(r);
        // const report = ReportsComponent.defaultReport[r];

        // params[r] = JSON.parse(JSON.stringify(report));
        // TODO: put reports into customeroverview when coming from "PDF PREVIEW"
        params[r] = search.reports ? search.reports[r] : JSON.parse(JSON.stringify(ReportsComponent.defaultReport[r]));
        params[r].issuer = search.issuer;
        params[r].customers = search.customers;
        params[r].customerDocumentNumbers = search.customerDocumentNumbers;
        params[r].manager = search.manager;
        params[r].filterInternal = true;
        params[r].limit = search.attachedReports[r].showAll ? undefined : search.attachedReports[r].limit;
        params[r].businessUnits = search.businessUnits;
        params[r].country = search.country;
        params[r].finishedProducts = search.finishedProducts;
        if (!search.quickLink) params[r].dateFrom = search.dateFrom;
        switch(r) {
          case 'srpfin':
          case 'lastinvoices':
            params[r].finishedProduct = search.finishedProduct;
            if (!search.quickLink) {
              // params[r].dateFrom = search.dateFrom;
              params[r].dateTo = search.dateTo;
            }
            params[r].docs = sr ?
              { in: true, pfin: true, cn: false, pfcn: false }
              : { in: true, pfin: false, cn: true, pfcn: false };
            params[r].sampleRequest = sr ? 2 : 3;
            break;
          case 'srnoninvoiced':
          case 'noninvoicedEM':
          case 'noninvoicedMachinery':
          case 'noninvoiced':
            params[r].finishedProduct = search.finishedProduct;
            if (!search.quickLink) {
              // params[r].dateFrom = null;
              params[r].dateTo = null;
            }
            params[r].sampleRequest = sr ? 2 : 3;
            params[r].businessUnits = 'noninvoicedEM' === r 
              ? this.data.businessUnits.filter(bu => ['EM'].includes(bu.code)).map(m => mongoId(m))
              : 'noninvoicedMachinery' === r 
                ? this.data.businessUnits.filter(bu => ['VI', 'MM', 'BA', 'AM', 'FX'].includes(bu.code)).map(m => mongoId(m))
                : search.businessUnits;
            console.log('~~~~~~~~~~~~', r, params);
            break;
          case 'dueinvoices':
            if (!search.quickLink) {
              // params[r].dateFrom = null;
              params[r].dateTo = null;
            }
            break;
          case 'offers':
            params[r].finishedProduct = search.finishedProduct;
            params[r].offerStatus = [ true, true, true, true, true, true ];
            if (!search.quickLink) {
              // params[r].dateFrom = search.dateFrom;
              params[r].dateTo = search.dateTo;
            }
            break;
          case 'orders':
            params[r].finishedProduct = search.finishedProduct;
            params[r].relatedOcs = 1; // 1 = none, 2 = all, 3 = non invoiced
            params[r].relatedInvoices = 1; // 1 = not paid, 2 = partially paid, 3 = fully paid
            params[r].relatedCreditNotes = 1; // 1 = none 2 = all
            if (!search.quickLink) {
              // params[r].dateFrom = search.dateFrom;
              params[r].dateTo = search.dateTo;
            }
            break;
        }
        tmp.push({r, params});
        // console.log('get attached reports', tmp, search);
      }
    }

    // if (search.quickLink) {
    //   reports = tmp.map(r => r.params);
    // } else {
    //   for (const type of search.sort) {
    //     const rep = tmp.find(t => type === t.r
    //       || (type === 'srpfin' && t.r === 'lastinvoices' && t.params.lastinvoices.sampleRequest === 2)
    //       || (type === 'srnoninvoiced' && t.r === 'noninvoiced' && t.params.noninvoiced.sampleRequest === 2));
    //     rep && reports.push(rep.params);
    //   }
    //   // reports = search.sort.map(s => tmp.find(f => f.r === s).params);
    // }
    // console.log(search, reports);

    if (search.quickLink) {
      reports = ReportsComponent.defaultReport.customeroverview.sort.map(s => (tmp.find(f => f.r === s) || {}).params).filter(f => f);
    } else {
      reports = search.sort.map(s => (tmp.find(f => f.r === s) || {}).params).filter(f => f);
    }

    for (const rep of reports) {
      if (rep['srpfin']) {
        rep['lastinvoices'] = rep['srpfin'];
        delete rep['srpfin'];
      }
      if (rep['srnoninvoiced']) {
        rep['noninvoiced'] = rep['srnoninvoiced'];
        delete rep['srnoninvoiced'];
      }
      if (rep['noninvoicedEM']) {
        rep['noninvoiced'] = rep['noninvoicedEM'];
        delete rep['noninvoicedEM'];
      }
      if (rep['noninvoicedMachinery']) {
        rep['noninvoiced'] = rep['noninvoicedMachinery'];
        delete rep['noninvoicedMachinery'];
      }
    }

    return reports;
  }

  reportsData = []
  accountManagers = [];
  accountManagerNames = undefined;
  secondRunReportsCount = 0;
  reportLoaded(data = null) {

    // console.log('reportLoaded', data);

    if (!this.secondRun && data) {
      this.reportsData.push(data);
      if (++this.reportsLoaded === this.attachedReports.length) {
        this.accountManagers = Array.from(new Set(this.reportsData.flatMap(r => r.pdfData.map(m => m.accountManager)))).filter(notNull => notNull).sort().map(m => {
          const reports = JSON.parse(JSON.stringify(this.attachedReports));
          const resultReports = [];
          reports.forEach(reps => {
            for (let i in reps) {
              const hasData = this.reportsData?.find(f => f.params?.[i]?.sampleRequest === reps[i]?.sampleRequest && f.pdfData?.find(f => {
                return f.accountManager === m
              }));
              if (hasData) {
                this.secondRunReportsCount++;
                const rep = {}
                rep[i] = reps[i];
                resultReports.push(rep);
                reps[i].manager = mongoId(this.data.users.find(f => f.name === m).contact);
              }
            }
          })
          console.log(reports, resultReports);
          return { name: m, reports: resultReports }
        })
        this.accountManagerNames = this.accountManagers?.map(m => m.name).join(', ');

        this.secondRun = true;
      }
    } else if (!this.secondRun) {
      if (++this.reportsLoaded === this.attachedReports.length) {
        console.log('loading reports completed')
        this.loading = false;
        this.done.emit(this.search);
      }
    } else {
      console.log('reports loaded (manager 2nd run):', this.reportsLoaded, this.secondRunReportsCount);
      if (--this.secondRunReportsCount == 0) {
        console.log('loading reports by manager 2nd run completed')
        this.loading = false;
        this.done.emit(this.search);
      }
    }
  }

  onClosePreview() {
    this.reportsData = [];
    this.accountManagers = [];
    this.secondRun = false;
    super.onClosePreview();
  }

  setManager(params: any, manager: any): any {
    params.manager = manager;
    return params;
  }

  getParams(params) {
    return JSON.stringify(params, null, 2);
  }
}
